// @flow

export default {
  LOCAL: 'local',
  ACCEPTATION: 'acceptation',
  PRODUCTION: 'production',
  END_TO_END: 'e2e'
};
